/* eslint-disable react/no-array-index-key */
import { memo } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import Button from '../Button';
import css from './QuestionReviewsHeader.module.scss';
import Fit from './Fit';
import NumericalDisplay from './NumericalDisplay';
import Rating from '../Rating';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var Question = function Question(_ref) {
  var fitRatingAvg = _ref.fitRatingAvg,
      onAskQuestion = _ref.onAskQuestion,
      colorways = _ref.colorways,
      questionsCount = _ref.questionsCount,
      ratingAvg = _ref.ratingAvg,
      reviewCount = _ref.reviewCount,
      shopifyId = _ref.shopifyId,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.rating,
      children: [/*#__PURE__*/_jsxs("h3", {
        className: cc(['ada-hidden', css.title]),
        children: [title, " Reviews"]
      }), reviewCount > 0 && /*#__PURE__*/_jsx(Rating, {
        count: 5,
        size: 24,
        value: ratingAvg
      }), /*#__PURE__*/_jsx("div", {
        className: css.counts,
        children: /*#__PURE__*/_jsx(NumericalDisplay, {
          count: questionsCount,
          type: "Question"
        })
      })]
    }), /*#__PURE__*/_jsx(Fit, {
      colorway: colorways.edges[0].node,
      fitRatingAvg: fitRatingAvg,
      reviewCount: reviewCount,
      shopifyId: shopifyId
    }), /*#__PURE__*/_jsx("div", {
      className: css.feedback,
      children: onAskQuestion && /*#__PURE__*/_jsx(Button, {
        "aria-label": "Have a question about this product? Submit your question, here.",
        bordered: true,
        onClick: onAskQuestion,
        children: "Ask A Question"
      })
    })]
  });
};

Question.defaultProps = {
  onAskQuestion: false,
  questionsCount: 0
};
Question.propTypes = {
  colorways: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({
      node: PropTypes.shape({
        variantStacks: PropTypes.arrayOf(PropTypes.shape({}))
      })
    }))
  }),
  fitRatingAvg: PropTypes.number.isRequired,
  questionsCount: PropTypes.number,
  ratingAvg: PropTypes.number.isRequired,
  reviewCount: PropTypes.number.isRequired,
  shopifyId: PropTypes.number.isRequired,
  onAskQuestion: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  title: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(Question);